import { configureStore } from '@reduxjs/toolkit';
import userReducer from './user/userSlice';
import configReducer from './config/configSlice';
import techReducer from './techdata/techdataSlice';
import medReducer from './meddata/meddataSlice';
import adminReducer from './admin/adminDataSlice';
import autoparkReducer from './admin/autoparkSlice';

export const store = configureStore({
  reducer: {
    user: userReducer,
    config: configReducer,
    admindata: adminReducer,
    autopark: autoparkReducer,
    techdata: techReducer,
    meddata: medReducer,
  },
});

export const baseURL = (store.getState() as RootState).config.baseURL + '/api';

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
